import { gql } from '@apollo/client'

export const Query = gql`
  query EditVehicle($companyId: ID!, $filters: VehicleFilters) {
    vehicles(companyId: $companyId, filters: $filters, first: 1) {
      nodes {
        id
        name
        registration
        warehouse {
          id
          name
        }
        rateCents
        mileageCents
        model
        manufacturer
        cabSize
        width
        height
        length
        payload
        notes
        costCents
      }
    }
  }
`
